import { z } from "zod"

export const addressSchema = z.object({
  countryId: z.string().min(1, { message: "Country is required" }),
  stateId: z.string().optional(),
  streetLine1: z.string().min(1, { message: "Address is required" }),
  streetLine2: z.string().optional(),
  city: z.string().min(1, { message: "City is required" }),
  postalCode: z.string(),
})
